export default Object.freeze({
  Provider_RP: '00F9EC05-D0C9-4E80-8244-2175A930E909',
  Pre_Interventor_RP: '141AB038-C4FA-4632-B407-5082E619B3B9',
  Director_URP: '3D37412D-3B41-446E-B846-F77967D2F463',
  AdminIL: '76129F36-5321-47B8-AE07-E5ADEE3417DF',
  Specialist_RP: '2843DB69-3643-4151-B62D-96405C105D91',
  Assistant_Provider_RP: '5D4ADD3D-121F-4400-BE3B-B41D3AC10011',
  Teacher: 'E879E31C-7046-416E-9405-9B8CCBF1A06C',
  Director: 'CC6325AA-8B93-40BA-BAC0-900B5EA038E9',
  Admin_RP: '17AE9A09-4939-4C75-9739-DD12DF782DE2',
});
